<mat-form-field>
    <mat-select
        [formControl]="componentFormControl"
        [class.hasValue]="!!value"
        [disableRipple]="true"
        panelClass="mg-configurator-select-panel"
    >
        <mat-option *ngFor="let option of options" [value]="option.value">
            {{ option.label }}
        </mat-option>
    </mat-select>
</mat-form-field>
